import { render } from "./contasreceber-list-nova.vue?vue&type=template&id=1ef7481d"
import script from "./contasreceber-list-nova.vue?vue&type=script&lang=js"
export * from "./contasreceber-list-nova.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__